<template lang="pug">
  div
    table.table
      thead
        tr.table__row.table__row--head
          th.table__cell {{ 'base.name' | translate }}
          th.table__cell
            days-count-toggler(v-model="days")
          th.table__cell {{ 'base.stock_rest' | translate }} [{{ 'base.kg' | translate }}]
          th.table__cell {{ 'base.dry_metter' | translate }} [{{ 'base.kg' | translate }}]
          th.table__cell {{ 'base.price' | translate }} [{{ 'base.currency' | translate }}]
          th.table__cell
      v-table-body(
        :cols="5"
        :loading="loading"
        :empty="!items.length")
        tr.table__row(
          v-for="item in items"
          :key="item.id")
          td.table__cell(
            @click="openRecipeDialog(item)")
            | {{ item.name }}
          td.table__cell
            span(:class="{ skeleton: wait }") {{ wait ? '' : Math.floor(item.daily_feed_intake * days) }} 
            span {{ wait ? '' : 'base.kg' | translate }}
          td.table__cell {{ item.total_amount | floor }}
          td.table__cell {{ item.is_animalfeed && item.dry_matter > 0  ? (item.dry_matter).toFixed(2) : item.dry_matter }}
          td.table__cell {{ item.total_price | floor }} {{ 'base.currency' | translate }}
          td.table__cell.table__cell--action
            v-btn(
              v-if="item.recipe"
              :disabled="isConsultant"
              icon
              @click="editFodder(item)")
              v-icon(
                font-size="1.1"
                icon="cog")

    //- TABLE PAGINATION
    ui-pagination(
      v-if="showPagination"
      v-model="page"
      :page-count="pageCount"
      @page-change="pageChangeHandler")

    v-dialog(
      max-width="1000"
      v-model="showCreateRecipeDialog"
      :value="showCreateRecipeDialog")
      create-recipe-dialog(
        @updated="loadData"
        :fodder="currentFodder"
        @on-close="showCreateRecipeDialog = false")

    v-dialog(
      max-width="700"
      v-model="showMixDialog"
      :value="showMixDialog")
      mix-fodder-dialog(
        @updated="loadData"
        :current-item="currentItem"
        @on-close="showMixDialog = false")
    v-dialog(
      max-width="340"
      v-model="showEditModal"
      :value="selectedFodder")
      edit-fodder-modal(
        @updated="loadData"
        :data="selectedFodder"
        @close="showEditModal = false")
</template>

<script>
import api from '@/api'
import { mapActions, mapGetters } from 'vuex'

import paginationMixin from '@/mixins/pagination.mixin'
import EditFodderModal from '../modals/EditFodderModal'
import CreateRecipeDialog from '../modals/CreateRecipeDialog'
import MixFodderDialog from '../modals/MixFodderDialog'
import DaysCountToggler from '../../ingredients/table/DaysCountToggler.vue'

export default {
  name: 'FodderTable',

  mixins: [paginationMixin],

  components: {
    CreateRecipeDialog,
    MixFodderDialog,
    EditFodderModal,
    DaysCountToggler
  },
  data: () => ({
    showEditModal: false,
    showCreateRecipeDialog: false,
    showMixDialog: false,
    currentItem: null,
    selectedFodder: null,
    currentFodder: null,
    wait: true,
    days: 1
  }),

  computed: {
    ...mapGetters('ingredients', [
      'getDailyFeedIntakesData'
    ]),
    dailyFeedIntakesData () {
      return this.getDailyFeedIntakesData
    },
    allowCraft () {
      return this.hasPermission('animalfeed_delivery', 'add')
    }
  },

  mounted () {
    this.setupPagination(
      api.ingredients.list,
      {
        farm: this.$route.params.farm_id,
        is_animalfeed: true
      }
    )

    this.$root.$on('UpdateFodderTable', () => {
      this.setupPagination(
        api.ingredients.list,
        {
          farm: this.$route.params.farm_id,
          is_animalfeed: true
        }
      )
    })
  },

  methods: {
    ...mapActions('recipes', [
      'selectRecipe'
    ]),

    async loadDailyFeedIntakes () {
      // Перевірка чи є items перед завантаженням
      if (!this.items || this.items.length === 0) {
        this.wait = false
        return
      }

      this.wait = true
      try {
        const { data } = await api.ingredients.dailyFeedIntakes({
          farm: this.$route.params.farm_id,
          is_animalfeed: true,
          page: this.page,
          offset: (this.page - 1) * 100 || null
        })
        this.items.forEach(item => {
          const updatedItem = data.find(d => d.id === item.id)
          if (updatedItem) {
            item.daily_feed_intake = updatedItem.daily_feed_intake
          }
        })
        this.wait = false
        this.$forceUpdate()
      } catch (error) {
        console.error('Error loading daily feed intakes:', error)
        this.wait = false
      }
    },

    getRestOfDays (item) {
      if (item.daily_feed_intake > 0) {
        return Math.floor(item.total_amount / item.daily_feed_intake)
      }
      return '-'
    },

    shortVersion (str) {
      return str.length > 24 ? (str.substring(0, 24) + '...') : str
    },

    daysLeft (item) {
      const value = Math.floor(item.total_amount / item.daily_feed_intake)
      if (value === Infinity) {
        return '-'
      }
      return !isNaN(value) ? value : 0
    },
    async loadRecipe (id) {
      try {
        await this.selectRecipe(id)
      } catch (error) {
        console.error('Error loading recipe:', error)
      }
    },

    openRecipeDialog (item) {
      const recipeId = item.recipe
      if (recipeId !== null) {
        this.currentItem = item

        this.loadRecipe(recipeId)
      } else {
        this.currentFodder = item
        this.showCreateRecipeDialog = true
      }
    },
    editFodder (item) {
      this.selectedFodder = item
      this.showEditModal = true
    }
  },

  watch: {
    items: {
      handler (newItems) {
        // Перевіряємо що items це комбікорм (is_animalfeed === true)
        if (newItems && newItems.length > 0 && newItems[0].is_animalfeed) {
          this.loadDailyFeedIntakes()
        }
      },
      immediate: false
    },
    page () {
      this.loadDailyFeedIntakes()
    },
    dailyFeedIntakesData () {
      // Перевіряємо що items це комбікорм перед завантаженням
      if (this.items && this.items.length > 0 && this.items[0].is_animalfeed) {
        this.loadDailyFeedIntakes()
      }
    }
  }
}
</script>

<style scoped>
span.skeleton {
  width: 3rem;
  display: inline-block;
  height: 1.5rem;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>